import { createContext, useContext } from 'react';
import type { IframeParams } from '@/lib/iframe-params';

export interface AuthContextType {
  authToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  authError: Error | null;
  loginWithOAuthCode?: (token: string, user: any) => Promise<void>;
  logout: () => void | Promise<void>;
  user: any | null;
  iframeParams: IframeParams;
  ssoUserId: string | null;
  username: string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
